import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { NavBar } from "@/components/NavBar";
import { OfflineBanner } from "@/components/OfflineBanner";
import { DriveStatusBanner } from "@/components/DriveStatusBanner";
import { OnboardingTour } from "@/components/OnboardingTour";
import { Footer } from "@/components/Footer";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Home from "@/pages/Home";
import VueCarriere from "@/pages/VueCarriere";
import FrontDetail from "@/pages/FrontDetail";
import FrontScan from "@/pages/FrontScan";
import InspectionForm from "@/pages/InspectionForm";
import VisitForm from "@/pages/VisitForm";
import InspectionReport from "@/pages/InspectionReport";
import ReactivationWorkflow from "@/pages/ReactivationWorkflow";
import AdminLayout from "@/pages/admin/AdminLayout";
import Help from "@/pages/Help";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import { Toaster } from "@/components/ui/sonner";

function AppRoutes() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="min-h-screen flex flex-col">
      <OfflineBanner />
      <DriveStatusBanner />
      <NavBar />
      <OnboardingTour />
      <div className="flex-1">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/aide" element={<Help />} />
          <Route path="/confidentialite" element={<PrivacyPolicy />} />
          <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/vue-carriere" element={<ProtectedRoute><VueCarriere /></ProtectedRoute>} />
          <Route path="/front/:frontId" element={<ProtectedRoute><FrontDetail /></ProtectedRoute>} />
          <Route path="/scan/:frontId" element={<ProtectedRoute><FrontScan /></ProtectedRoute>} />
          <Route path="/inspection/new/:frontId" element={<ProtectedRoute><InspectionForm /></ProtectedRoute>} />
          <Route path="/visite/nouvelle/:type" element={<ProtectedRoute><VisitForm /></ProtectedRoute>} />
          <Route path="/inspection/:inspectionId/rapport" element={<ProtectedRoute><InspectionReport /></ProtectedRoute>} />
          <Route
            path="/remise-en-service/:frontId"
            element={<ProtectedRoute roles={["RESPONSABLE", "ADMINISTRATEUR"]}><ReactivationWorkflow /></ProtectedRoute>}
          />
          <Route
            path="/admin"
            element={<ProtectedRoute roles={["RESPONSABLE", "ADMINISTRATEUR"]}><AdminLayout /></ProtectedRoute>}
          />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0D12] text-slate-100">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
